import type { Messages } from '@/i18n/messages/en/index.ts'

/** What the groups domain's refusals say, in Brazilian Portuguese (checked against the English shape at compile time). */
export const groups: Pick<
  Messages['errors'],
  | 'groups.gone'
  | 'groups.not_found'
  | 'groups.picked_one_is_gone'
  | 'groups.name_taken'
  | 'groups.not_created'
  | 'groups.nothing_to_change'
  | 'groups.changed_while_editing'
  | 'groups.only_administrators'
  | 'groups.members_are_private'
  | 'groups.only_managers_can_add'
  | 'groups.only_managers_can_remove'
  | 'groups.only_managers_can_find_people'
  | 'groups.no_longer_managed_by_you'
  | 'groups.service_account_cannot_manage'
  | 'groups.deactivated_account_cannot_manage'
  | 'groups.confirm_name_to_delete'
  | 'groups.deletion_changed'
  | 'groups.new_owner_required'
  | 'groups.new_owner_must_differ'
> = {
  'groups.gone': () => 'Esse grupo não existe mais.',
  'groups.not_found': () => 'Não existe nenhum grupo com esse id.',
  'groups.picked_one_is_gone': () => 'Um grupo que você escolheu não existe mais. Recarregue e escolha de novo.',

  // The group's name is user content and is never translated (D-17).
  'groups.name_taken': ({ name }) => `Já existe um grupo chamado “${name}”.`,
  'groups.not_created': () => 'Não foi possível criar o grupo.',
  'groups.nothing_to_change': () => 'Não há nada para alterar.',
  'groups.changed_while_editing': () =>
    'Alguém alterou este grupo enquanto você o editava. Recarregue e tente de novo.',

  'groups.only_administrators': () => 'Só administradores podem fazer isso com grupos.',
  // "Só quem mantém" is D-37's bound phrasing; the members of a group read the same way.
  'groups.members_are_private': () =>
    'Só quem está neste grupo, quem o gerencia e administradores podem ver quem faz parte dele.',
  'groups.only_managers_can_add': () => 'Só quem gerencia este grupo e administradores podem adicionar pessoas.',
  'groups.only_managers_can_remove': () => 'Só quem gerencia este grupo e administradores podem remover pessoas.',
  'groups.only_managers_can_find_people': () =>
    'Só quem gerencia algum grupo e administradores podem procurar pessoas.',
  'groups.no_longer_managed_by_you': () => 'Você não gerencia mais este grupo.',

  'groups.service_account_cannot_manage': () => 'Uma conta de serviço não pode gerenciar um grupo.',
  // "desativada" agrees with "conta", which is feminine.
  'groups.deactivated_account_cannot_manage': () => 'Essa conta está desativada, então não pode gerenciar um grupo.',

  'groups.confirm_name_to_delete': ({ name }) => `Digite ${name} para confirmar que este grupo deve ser excluído.`,
  'groups.deletion_changed': () =>
    'O que a exclusão deste grupo muda mudou desde a última vez que você olhou. Revise de novo antes de excluir.',
  'groups.new_owner_required': () => 'Escolha a quem vai pertencer o que este grupo tem antes de excluí-lo.',
  'groups.new_owner_must_differ': () => 'Escolha outro grupo para ficar com esses itens.'
}
